import { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../Components/Navbar/Header';
import Footer from '../../Components/Footer/Footer';
import ShopByBrandsBanner from '../../Components/BrandsBanner';
import InfoBanner from '../../Components/InfoBanner';
import CategoryComponent from '../../Components/CategoryComponent';
import Combo from '../../Components/Showrooms/Combo';
import PhoneDeals from '../../Components/PhoneDeals';
import LaptopDeals from '../../Components/LaptopDeals';
import RefrigeratorDeals from '../../Components/RefrigeratorDeals';
import TelevisionDeals from '../../Components/TelevisionDeals';
import AppliancesDeals from '../../Components/AppliancesDeals';
import SpeakerDeals from '../../Components/SpeakerDeals';
import AccessoriesDeals from '../../Components/AccDeals';
// import SamsungDeals from '../../Components/SamsungDeals';





export default function Home() {
  useLayoutEffect(() => {
    // Scroll to top on page load
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Enables smooth scrolling
    });
  }, []); // Empty dependency array to run only once when the component mounts

  return (
    <div>
      <Helmet>
        <title>Franko Trading | Best Phones & Electronics Deals in Ghana
        </title>
        <meta
          name="description"
          content="Shop high-quality phones, laptops, and accessories at the best prices in Ghana. Fast delivery & top deals at Franko Trading!"
        />
        <meta
          name="keywords"
          content="Shop high-quality phones, laptops, and accessories at the best prices in Ghana. Fast delivery & top deals at Franko Trading!"
        />
        <meta name="author" content="Franko Trading Enterprise" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Franko Trading | Home" />
        <meta
          property="og:description"
          content="Discover unbeatable deals on mobile phones, laptops, and tech accessories at Franko Trading. Quality products, great prices, and fast delivery across Ghana."
        />
       <meta
  property="og:image"
  content={`${window.location.origin}/assets/frankoIcon.png`}
/>

        <meta property="og:url" content="https://www.frankotrading.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Franko Trading | Home" />
        <meta
          name="twitter:description"
          content="Shop Franko Trading for mobile phones, laptops, and tech accessories in Ghana. Affordable prices, premium quality, and trusted service."
        />
        <meta
          name="twitter:image"
          content="https://www.frankotrading.com/assets/frankoIcon.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <Header />
      <CategoryComponent />
      
      
   
    
      <PhoneDeals/>
    <LaptopDeals/>
    <RefrigeratorDeals/>
    <TelevisionDeals/>
    <AppliancesDeals/>
    <AccessoriesDeals/>
    <SpeakerDeals/>
    <ShopByBrandsBanner />
    {/* <SamsungDeals/> */}
      <InfoBanner />
      <Combo />
  
      
      <Footer />
    </div>
  );
}
